import { getAuthAxiosBackend } from "@/helpers/axios"

class InstitutionsServices {
    get(id) {
        return getAuthAxiosBackend().get('Institutions/getInstitutionsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Institutions/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Institutions/addInstitutions', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Institutions/updateInstitutions/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Institutions/restoreInstitutions' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Institutions/softDeleteInstitutions/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Institutions/deleteInstitutions/' + id.toString())
    }
}

export default new InstitutionsServices()
